import * as leadformConstants from '../constants';

export default function getPanels(element){
  return [...element.querySelectorAll(leadformConstants.leadformClasses.panel)];
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/element/get_panels.js